import React, { useEffect, useState } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import ApiConnect from "../../../Utils/ApiConnect";
import QuickView from "../../Components/QuickView";
import DeletePop from "../../Components/DeletePop";
import FileViewer from "../../Components/FileViewer";
import AutoComplete from "../../Components/AutoComplete";
export default function LedgerBook() {
  const [startDate, SetstartDate] = useState(new Date());
  const [endDate, SetendDate] = useState(new Date());
  const [selectedAccount, SetAccountid] = useState(false);
  const [AccountHeads, setAccountheads] = useState(false);
  const [tableData, SettableData] = useState([]);
  const [totalData, SettotalData] = useState([]);
  const [loading, Setloading] = useState(true);
  const [showQucik, SetshowQuick] = useState(false);
  const [selectedId, SetselectedId] = useState(false);
  const [selectedType, SetselectedType] = useState(false);
  const [triggerModal, SettriggerModal] = useState(false);
  const [viewerTrigger, SetviewerTrigger] = useState(false);
  const [selectedFile, SetselectedFile] = useState(false);

  const fetchDayBook = () => {
    ApiConnect.get(
      `/Module/Accounts/Report/LedgerBook?account=${selectedAccount}&from=${format(
        startDate,
        "yyyy-MM-dd"
      )}&to=${format(endDate, "yyyy-MM-dd")}`
    )
      .then((response) => {
        SettableData(response.data.tableData);
        SettotalData(response.data.totalData);
        Setloading(false);
      })
      .catch((err) => console.log(err));
  };
  const fetchEmployee = () => {
    ApiConnect.get("/Module/Accounts/AccountHead/Details")
      .then((response) => {
        setAccountheads(response.data);
      })
      .catch((error) => console.log(error));
  };
  useEffect(() => {
    fetchEmployee();
  }, []);
  const columns = [
    {
      key: "date",
      text: "Date",
      sortable: true,
    },
    {
      key: "miti",
      text: "Miti",
      sortable: true,
    },
    {
      key: "id",
      text: "Voucher No",
      sortable: true,
      cell: (record) => {
        return (
          <a
            onClick={() => {
              SetselectedId(record.id);
              SetselectedType(record.type);
              SetshowQuick(true);
            }}
            href="#_"
          >
            {record.id}
          </a>
        );
      },
    },
    {
      key: "description",
      text: "Description",
      sortable: true,
      cell: (record) => {
        return (
          <React.Fragment>
            {record.description}
            <div className="avatar-list avatar-list-overlap">
              {record.attachment
                ? record.attachment.map((att, i) => (
                    <a
                      className="avatar"
                      onClick={() => {
                        SetselectedFile(att);
                        SetviewerTrigger(true);
                      }}
                      key={i}
                      href="#_"
                    >
                      <img src={att} alt={`${record.id}${i}`} />
                    </a>
                  ))
                : ""}
            </div>
          </React.Fragment>
        );
      },
    },
    {
      key: "debit",
      text: "Debit",
      sortable: true,
    },
    {
      key: "credit",
      text: "Credit",
      sortable: true,
    },
    {
      key: "ending_balance",
      text: "Ending Balance",
      sortable: true,
    },
    {
      key: "user",
      text: "Posted By",
      sortable: true,
      cell: (record) => {
        return (
          <React.Fragment>
            <img
              src={record.user.avatar}
              className="avatar"
              alt={record.user.name || record.user.id}
            />
          </React.Fragment>
        );
      },
    },
    {
      key: "id" + 1,
      text: "Action",
      sortable: true,
      cell: (record, i) => {
        return (
          <React.Fragment key={i}>
            <button
              className="table-action btn btn-square btn-pure hover-success"
              onClick={() => {
                SetselectedId(record.id);
                SetselectedType(record.type);
                SetshowQuick(true);
              }}
            >
              <span className="material-icons-outlined">visibility</span>
            </button>
            <button
              className="table-action btn btn-square btn-pure hover-danger"
              onClick={() => {
                SetselectedId(record.id);
                SettriggerModal(true);
              }}
            >
              <span className="material-icons-outlined">delete</span>
            </button>
          </React.Fragment>
        );
      },
    },
  ];
  const config = {
    key_column: "id",
    page_size: 30,
    length_menu: [30, 60, 90],
    show_filter: true,
    show_pagination: true,
    button: {
      excel: false,
      print: false,
    },
    language: {
      loading_text: "Please be patient while data loads...",
    },
  };

  const autoCompleteAction = (data) => {
    SetAccountid(data.id);
  };
  return (
    <React.Fragment>
      <div className="card card-shadowed animated fadeInDownBig ng-scope">
        <div className="card-title row">
          <h2 className="col-4">Ledger Book</h2>
          <div className="row">
            <div className="col-4 form-group">
              <label>Account Head</label>
              {AccountHeads ? (
                <AutoComplete
                  name="accounthead"
                  action={autoCompleteAction}
                  placeHolder="Account Head"
                  styleName=""
                  items={AccountHeads}
                />
              ) : (
                ""
              )}
            </div>
            <div className="form-group col-6 row">
              <div className="col">
                <label>From</label>
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  maxDate={new Date()}
                  closeOnScroll={true}
                  selected={startDate}
                  value={startDate}
                  onChange={(e) => {
                    SetstartDate(e);
                  }}
                  withPortal
                  showMonthDropdown
                  placeholderText="Select Day"
                />
              </div>
              <div className="col">
                <label>to</label>
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  maxDate={new Date()}
                  closeOnScroll={true}
                  selected={endDate}
                  value={endDate}
                  minDate={startDate}
                  onChange={(e) => {
                    SetendDate(e);
                  }}
                  withPortal
                  showMonthDropdown
                  placeholderText="Select Day"
                />
              </div>
            </div>
            <button
              className="btn btn-secondary col"
              onClick={() => {
                SetendDate(new Date());
                SetstartDate(new Date());
              }}
            >
              Reset
            </button>
            <button
              className="btn btn-primary col"
              onClick={() => fetchDayBook()}
            >
              Fetch
            </button>
          </div>
        </div>
      </div>
      <QuickView
        trigger={showQucik}
        type={selectedType}
        id={selectedId}
        hideTrigger={SetshowQuick}
      />
      <DeletePop
        trigger={triggerModal}
        delUrl={`/Module/Vouchers/Main/Delete?id=${selectedId}`}
        hideTrigger={SettriggerModal}
        fallAction={fetchDayBook}
      />
      <FileViewer
        trigger={viewerTrigger}
        doc={selectedFile}
        hideTrigger={SetviewerTrigger}
      />
      <div className="card">
        <h4 className="card-title">
          Results form
          <strong> {format(startDate, "yyyy-MM-dd")}</strong> to{" "}
          <strong>{format(endDate, "yyyy-MM-dd")}</strong>
        </h4>
        <div className="card-body">
          <div className="row">
            <div className="col-lg-12">
              <ReactDatatable
                className="table"
                config={config}
                records={tableData}
                columns={columns}
                loading={loading}
              />
            </div>
            <div className="col-md-6">
              <table className="table table-striped table-bordered">
                <tbody>
                  <tr>
                    <td style={{ textAlign: "right" }} width={200}>
                      Total Debit Amount :
                    </td>
                    <td>{(totalData.debit || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right" }} width={200}>
                      Total Credit Amount :
                    </td>
                    <td>{(totalData.credit || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right" }} width={200}>
                      Total Difference :
                    </td>
                    <td>
                      {(
                        (totalData.debit || 0) - (totalData.credit || 0)
                      ).toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right" }} width={200}>
                      Actual Balance :
                    </td>
                    <td>{totalData.balance || 0}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
